import { useState, useEffect } from 'react';
import tenantStorage from '../../services/tenantStorage';

/**
 * Manages business day state (isBusinessDay + salesDate).
 * Shared between CashierSalesPage and WaiterSalesPage.
 *
 * On Cashier, the session manager hook calls setIsBusinessDay / setBusinessDaySalesDate
 * directly when an active session exists, so this hook no longer needs activeSession.
 */
const useBusinessDay = () => {
    const [isBusinessDay, setIsBusinessDay] = useState(false);
    const [businessDaySalesDate, setBusinessDaySalesDate] = useState('');

    useEffect(() => {
        const load = async () => {
            try {
                const state = await tenantStorage.getBusinessDayState();
                setIsBusinessDay(state.isBusinessDay || false);
                setBusinessDaySalesDate(state.salesDate || '');
            } catch (error) {
                console.error('Error loading business day state:', error);
                setIsBusinessDay(false);
                setBusinessDaySalesDate('');
            }
        };
        load();
    }, []);

    const updateBusinessDayState = async () => {
        try {
            const state = await tenantStorage.getBusinessDayState();
            setIsBusinessDay(state.isBusinessDay || false);
            setBusinessDaySalesDate(state.salesDate || '');
        } catch (error) {
            console.error('Error updating business day state:', error);
        }
    };

    return {
        isBusinessDay,
        setIsBusinessDay,
        businessDaySalesDate,
        setBusinessDaySalesDate,
        updateBusinessDayState,
    };
};

export default useBusinessDay;
